import {
  Identifiable,
  Project,
  ProjectPortfolio,
  projectStatus,
  Zone,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { formatDate } from "../utils/formatDate";
import { LinkedProject, Linker } from "../linkers/types";
import { mapError } from "../utils/mapError";

type Response = LinkedProject;

function duplicateProjectFromModel(httpClient: HttpClient, linker: Linker) {
  return (
    projectModel: Identifiable<Project>,
    project: Project & {
      portfolios: Identifiable<ProjectPortfolio>[];
    },
    zone: Identifiable<Zone>,
  ) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: `/projects/${projectModel.uuid}/create-from-template`,
        method: HttpMethods.POST,
        data: {
          name: project.name,
          description: project.description,
          ...(project.rootList.startDate && {
            startDate: formatDate(project.rootList.startDate),
          }),
          ...(project.rootList.endDate && {
            endDate: formatDate(project.rootList.endDate),
          }),
          tags: project.tags.map((tag) =>
            typeof tag === "string" ? tag : tag.name,
          ),
          status: `projectStatuses/${project.status.uuid}`,
          zone: `zones/${zone.uuid}`,
          portfolioUuids: project.portfolios.map(({ uuid }) => uuid),
          data: { ...projectModel.data, ...projectModel.attributes },
          attributes: { ...projectModel.attributes, ...project.attributes },
        },
      })
      .then(linker.linkProject)
      .then((project) => ({
        ...project,
        status: project.status || projectStatus,
        isTemplate: project.isTemplate || (project.template as boolean),
      }))
      .catch((e) =>
        Promise.reject(
          mapError(e, {
            invalidProjectName: "invalidProjectName",
          }),
        ),
      );
}

export { duplicateProjectFromModel };
